<template>
    <div class="wrapper">
        <div name="home" class="home">
            <div class="header" v-if="centerName !== '' && centerName !== null">{{ centerName }}</div>
            <patient-info v-if="state === 0" 
                @nextStep="nextStep"
                @onError="onError"
            />
            <card-info v-else-if="state === 1" 
                @nextStep="nextStep"
                @onError="onError"
                @onCardError="onCardError"
                :centerId="isDefault ? null : centerId"
            />
            <booking v-else/>
            <page-footer 
                :state="state"
            />
            <error-modal 
                v-if="error !== ''"
                :error="error"
                @onClose="closeModal"
            />
            <card-error-modal 
                v-if="cardError !== ''"
                :error="cardError"
                @onClose="closeModal"
            />
        </div>
    </div>
</template>

<script>
// compnents 3 
// patient info, card info, booking
import PatientInfo from '@/components/organisms/PatientInfo';
import CardInfo from '@/components/organisms/CardInfo';
import Booking from '@/components/organisms/Booking';
import {mapState} from 'vuex';
import Constant from '@/constant';
import PageFooter from '@/components/molecules/PageFooter';
import ErrorModal from '@/components/modals/ErrorModal';
import CardErrorModal from '@/components/modals/CardErrorModal';

export default {
    name: 'home',
    components: {
        PatientInfo,
        CardInfo,
        Booking,
        PageFooter,
        ErrorModal,
        CardErrorModal
    },
    computed: mapState(['profile', 'agreements', 'card_info']),
    data: function(){
        return {
            state: 0,
            error: '',
            cardError: '',
            centerId: null,
            isDefault: true,
            centerName: ''
        }
    },
    mounted: function() {
        ChannelIO('boot', {
            "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8"
        });
        this.$store.commit(Constant.INITIALIZE_PROFILE);
        this.$store.commit(Constant.INITIALIZE_AGREEMENTS);
        this.$store.commit(Constant.INITIALIZE_CARD_INFO);
        this.centerId = this.$route.params.centerid;
        
        if(this.centerId === undefined || this.centerId === null || this.centerId === '')
        {
            this.isDefault = true;
        }
        else
        {
            this.$store.dispatch(Constant.FETCH_BAROCARE_NAME, {uuid: this.centerId})
                .then((res) => {
                    this.centerName = res.name;
                })
                .catch((err) => {

                })

            this.isDefault = false;
        }
    },
    methods: {
        onError: function(error){
            this.error = error;
        },  
        onCardError: function(error)
        {
            this.cardError = error;
        },
        nextStep: function(step)
        {
            this.state = step;
        },
        closeModal: function()
        {
            this.error = '';
            this.cardError = '';
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .home {
        width: 100%;
    }
    .header {
        background: var(--Gray-20, #F3F5F8);
        width: 100%;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 108.333% */
        box-sizing: border-box;
        padding: 16px;;
    }
    @media (min-width: 600px) {
        .home {
            width: 600px;
        }

    }
</style>


// WEBPACK FOOTER //
// src/page/Home.vue